import React, { forwardRef, useEffect, useState } from 'react'
import { Button } from '@ow/comps'
import { showNotification } from '@mantine/notifications'
import {
  useAppEx,
  useFetchRemoteData,
  useDetailStore,
  useProcessStore,
  useTbViewStore,
} from '@vt/hooks'
import { WebBasicForm } from '@ow/ditto'
import { upload } from '@vt/apis/lib-ex/v2/givrali'
import {
  fetchUcaseExtBackFill,
  batchUpsertCollectionData,
} from '@vt/apis/lib-ex/v2/tables'
import { get, pick } from 'lodash-es'
import { ResizableBox } from 'react-resizable'
import styled from '@emotion/styled'
import StandardScore from '../standardScore'

const StyledButtons = styled.div`
  padding: 24px 24px 10px;
  border-top: 1px solid #e7e7e7;
  display: flex;
  justify-content: end;
  button + button {
    margin-left: 15px;
  }
`
const StyledForm = styled.div`
  padding: 23px 32px 23px 18px;
`
const StyledResizableBox = styled(ResizableBox)`
  box-shadow: 0 -2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: auto;

  .react-resizable-handle {
    position: absolute;
    width: 100%;
    height: 10px;
    right: 0;
    top: 0;
    cursor: n-resize;
    z-index: 1;
  }
`

const Content = function (
  { setShowContent, setDataById, tbId, detailFormRef },
  ref
) {
  const [height, setHeight] = useState(0)
  const [minHeight, setMinHeight] = useState(0)
  const onResize = (event, { size }) => {
    setHeight(size.height)
  }
  const [standardScore, setScore] = useState([])
  const [isAllScore, setIsAllScore] = useState(false)

  const { appId, tbs, getDitto, userInfoInApp } = useAppEx((state) =>
    pick(state, ['appId', 'tbs', 'getDitto', 'userInfoInApp'])
  )

  const {
    setEditableSlugs,
    setEditableSlugFields,
    editableSlugs,
    isReCreate,
    setIsReCreate,
    setRefreshLog,
  } = useDetailStore((state) =>
    pick(state, [
      'setEditableSlugs',
      'setEditableSlugFields',
      'editableSlugs',
      'isReCreate',
      'setIsReCreate',
      'setRefreshLog',
    ])
  )
  const { setRefreshStatus, detailConfig } = useTbViewStore((state) =>
    pick(state, ['setRefreshStatus', 'detailConfig'])
  )

  const { updateStageNode, currentNode, data, setIsRefreshNode } =
    useProcessStore((state) =>
      pick(state, [
        'updateStageNode',
        'currentNode',
        'data',
        'setIsRefreshNode',
      ])
    )
  const [loading, setLoading] = useState(false)
  const { eventActionInfo } = currentNode
  const currentTbId = tbId

  /**
   * 是否显示指标打分组件
   * flowDataOfView.allowStandardScor 视图中配置了允许指标打分
   * currentNode.uuid 只有当前流程节点和视图中提前配置的内容一致
   * userInfoInApp.roleSlug 当前用户角色为 业务科室
   */
  const flowDataOfView = detailConfig && detailConfig.allowFlow
  const isShowStandardScore =
    flowDataOfView.allowStandardScore &&
    currentNode.uuid === flowDataOfView.standardScoreUuid &&
    userInfoInApp.roleSlug === 'zdy_yewukeshi'

  // 本表单
  const updateUcaseAction = get(eventActionInfo, 'updateUcaseAction', {})
  // 外表单
  const editFormAction = get(eventActionInfo, 'editFormAction', {})
  // 本表单渲染的字段
  const current_children = get(
    updateUcaseAction && updateUcaseAction.fields,
    'children',
    []
  )
  // 外表单渲染的字段
  const other_children = get(
    editFormAction && editFormAction.fields,
    'children',
    []
  )
  // 以下位新修改

  const dealUcaseExtBackFill = async () => {
    if (current_children) {
      // 请求自动派发的数据信息接口
      const arr = current_children.map((m) => m.slug)
      const res = await fetchUcaseExtBackFill(
        appId,
        tbId,
        data.objectId,
        currentNode.stageId,
        currentNode.uuid
      )

      const { processFields = {} } = detailConfig.allowFlow || {}

      // 处理自动派发
      const editableSlugFields = current_children.map((item) => {
        const obj = (res && res[item.slug]) || {}
        const props = {}
        if (obj.selects) {
          props.selects = obj.selects
        }
        if (obj.defaultValue) {
          props.defaultValue = obj.defaultValue
        }
        const field = tbs[item.tbId]
          ? tbs[item.tbId].fields.find((f) => f.slug === item.slug)
          : null

        return {
          slug: item.slug,
          opts: {
            ...field,
            ...props,
            ...(field ? processFields[field.slug] : {}),
          },
        }
      })

      setEditableSlugFields(editableSlugFields)
      setEditableSlugs(arr)
    }
  }
  useEffect(() => {
    dealUcaseExtBackFill()
  }, [eventActionInfo])

  // 以上为新修改

  useEffect(() => {
    // 标识为重新上报
    if (updateUcaseAction.allowAllUpdates) {
      console.log('重新上报')
      setIsReCreate(true)
    }
    // 判断外表单有没有slug
    if (other_children && other_children.length) {
      setHeight(isShowStandardScore ? 406 : 190)
      setMinHeight(isShowStandardScore ? 406 : 190)
    } else {
      setHeight(77)
      setMinHeight(77)
    }
  }, [eventActionInfo])

  // 其他表单要显示的tbDef
  let otherAllowedFields = null
  const otherTbId = editFormAction && editFormAction.tableTemplateId
  // 其他表单要显示的slug
  const otherSlugs = other_children.map((i) => i.slug)
  if (editFormAction) {
    const otherFields = tbs[otherTbId] ? tbs[otherTbId].fields : []
    otherAllowedFields = otherFields.filter((f) =>
      (otherSlugs || []).includes(f.slug)
    )
    otherAllowedFields = otherAllowedFields.map((item) => {
      return { ...item, hiddenWhenCreate: false }
    })
  }

  // 一共要显示的tbDef
  const allowedFields = otherAllowedFields

  const fetchStageNode = (currentMapData) => {
    setLoading(true)
    const obj = {
      createdData: {},
      updateData: {},
    }
    // 其他表单内容
    if (otherTbId) {
      const values = ref.current ? ref.current.getValues() : {}
      const otherMap =
        otherAllowedFields &&
        otherAllowedFields.map((f) => {
          return { [f.slug]: values[f.slug] }
        })
      const otherMapData = Object.assign({}, ...otherMap)
      obj.createdData[otherTbId] = otherMapData
    }
    // 当前表单内容
    if (Object.keys(currentMapData).length) {
      obj.updateData[currentTbId] = currentMapData
    }
    updateStageNode(obj)
      .then(() => {
        setDataById().then(() => {
          setEditableSlugs([])
          setEditableSlugFields([])
          if (setRefreshStatus) {
            setRefreshStatus(true)
          }
          setIsReCreate(false)
          setLoading(false)
          setIsRefreshNode(true)
          showNotification({
            title: '操作成功',
          })
          setRefreshLog(true)
          setShowContent('node')
        })
      })
      .catch(() => {
        setLoading(false)
      })
  }
  const toStandardScore = (currentMapData) => {
    if (isShowStandardScore) {
      if (!isAllScore) {
        showNotification({
          title: '请给指标打分！',
        })
      } else {
        batchUpsertCollectionData(
          appId,
          getDitto(
            null,
            'zhibiaoshifouhege_0468868f_1e1b_4055_a93b_9615dccb963d'
          ).tbNameId,
          standardScore
        ).then(() => {
          fetchStageNode(currentMapData)
        })
      }
    } else {
      fetchStageNode(currentMapData)
    }
  }
  const _onClickSubmit = () => {
    if (detailFormRef && detailFormRef.current) {
      detailFormRef.current.trigger().then(() => {
        detailFormRef.current.trigger().then((tr) => {
          console.log('data validate:', tr)
          if (tr) {
            const formData = detailFormRef.current.getValues()
            console.log('detailFormValue->>', pick(formData, editableSlugs))

            // 如果是重新上报，这里获取formData全部数据
            toStandardScore(
              isReCreate ? formData : pick(formData, editableSlugs)
            )
          }
          return null
        })
      })
    } else toStandardScore({})
  }
  const fetchRemoteData = useFetchRemoteData()
  // 返回
  const goback = () => {
    setEditableSlugs([])
    setEditableSlugFields([])
    setIsReCreate(false)
    setShowContent('node')
  }

  const setStandardScore = (val, isAll) => {
    setScore(val)
    setIsAllScore(isAll)
  }

  return (
    <StyledResizableBox
      width={Infinity}
      height={height}
      minConstraints={[Infinity, minHeight]}
      maxConstraints={[Infinity, 500]}
      onResize={onResize}
      resizeHandles={['n']}
      axis="y"
      className="customResizable flex flex-col"
    >
      <div className="overflow-y-scroll flex-1">
        {isShowStandardScore && (
          <StandardScore setStandardScore={setStandardScore} />
        )}
        {allowedFields && (
          <StyledForm>
            <WebBasicForm
              fields={allowedFields}
              data={data}
              onClickUpload={upload}
              ref={ref}
              onFetchRemoteData={fetchRemoteData}
            />
          </StyledForm>
        )}
      </div>
      <StyledButtons>
        <Button loading={loading} type="primary" onClick={_onClickSubmit}>
          提交
        </Button>
        <Button stroke onClick={goback}>
          返回
        </Button>
      </StyledButtons>
    </StyledResizableBox>
  )
}
export default forwardRef(Content)
